
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pengelolaan-kinerja-pamong/pegawai/pelaksanaan/praktik-kinerja/rencana-tindak-lanjut",
      function () {
        return require("private-next-pages/pengelolaan-kinerja-pamong/pegawai/pelaksanaan/praktik-kinerja/rencana-tindak-lanjut/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pengelolaan-kinerja-pamong/pegawai/pelaksanaan/praktik-kinerja/rencana-tindak-lanjut"])
      });
    }
  